import React from "react";
import TitlePage from "../../app/Title/TitlePage/TitlePageView";
import Grid from "@material-ui/core/Grid";
import {Fieldset} from "primereact/fieldset";
import {Button} from "primereact/button";
import {Column} from "primereact/column";
import {DataTable} from "primereact/datatable";
import Paper from "@material-ui/core/Paper";
import {InputText} from "primereact/inputtext";
import {Dropdown} from "primereact/dropdown";

const Capacity = ({headerCapacity}) => {
    return (
        <React.Fragment>
            <Paper elevation={5}
                   style={{paddingTop: '2%', paddingBottom: '2%', paddingLeft: '2%', paddingRight: '2%'}}>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <TitlePage title="Aforos"/>
                    </Grid>
                    <Grid item xs={12}>
                        <Fieldset legend="Filtros" toggleable={true} collapsed={true}>
                            <Grid container direction="row" justify="space-evenly" alignItems="center">
                                <Grid item>
                                    <Dropdown
                                        placeholder="Tipo de Aforo"
                                        filter={true}
                                        filterBy="label"
                                        showClear={true}
                                    />
                                </Grid>
                                <Grid item>
                                    <Dropdown
                                        placeholder="Emisora a Prestar"
                                        filter={true}
                                        filterBy="label"
                                        showClear={true}
                                    />
                                </Grid>
                                <Grid item>
                                    <Dropdown
                                        placeholder="Garantía"
                                        filter={true}
                                        filterBy="label"
                                        showClear={true}
                                    />
                                </Grid>
                                <Grid item>
                                    <label htmlFor="cb1" className="p-checkbox-label">Llamada de Margen</label>
                                    &nbsp;
                                    <InputText/>
                                </Grid>
                                <Grid item>
                                    <Grid container spacing={1}>
                                        <Grid item>
                                            <Button label="Limpiar"/>
                                        </Grid>
                                        <Grid item>
                                            <Button label="Buscar"/>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Fieldset>
                    </Grid>
                    <Grid item xs={12}>
                        <DataTable
                            header={headerCapacity}
                            responsive={true}>
                            <Column field="aforo" header="Tipo de Aforo"/>
                            <Column field="emisoraPresta" header="Emisora a Prestar"/>
                            <Column field="garantia" header="Garantía"/>
                            <Column field="porcRequerido" header="Porcentaje Requerido"/>
                            <Column header="Acciones"/>
                        </DataTable>
                    </Grid>
                </Grid>
            </Paper>
        </React.Fragment>
    )
};

export default Capacity;